import { ExportEmailDrawerTranslations } from "./export-email-drawer-pt-br";

export const EXPORT_EMAIL_DRAWER_ES_ES: ExportEmailDrawerTranslations = {
	title: "Exportaciones",
	description:
		"Informe el correo electrónico para recibir la planilla. La planilla será enviada en unos minutos y también estará disponible en 'Planillas exportadas' por 7 días.",
	form: {
		label: "E-mail",
		placeholder: "Digite seu email",
		required: "Email é obrigatório",
		emailInvalid: "El correo electrónico no es válido",
		submit: "Exportar planilha",
	},
};
